type Props = {
  total: number;
  step: number;
};

export function Stepper({ total, step }: Props) {
  return (
    <div className="tcg-stepper">
      {Array.from({ length: total }, (_, i) => {
        const idx = i + 1;
        const state = idx < step ? "done" : idx === step ? "active" : "";
        return <div key={i} className={`tcg-step-bar ${state}`} />;
      })}
    </div>
  );
}
